const validationMessages: Record<string, string> = {
    "email.tooShort": "Email musi zawierać co najmniej 5 znaków",
    "email.tooLong": "Email może zawierać maksymalnie 30 znaków",
    "email.invalidPattern": "Nieprawidłowy format adresu email",
    "password.tooShort": "Hasło musi zawierać co najmniej 8 znaków",
    "password.tooLong": "Hasło może zawierać maksymalnie 64 znaki",
    "password.invalidPattern": "Hasło musi zawierać małe i duże litery, cyfrę oraz znak specjalny",
    "competitionName.tooShort": "Nazwa zawodów musi zawierać co najmniej 3 znaki",
    "competitionName.tooLong": "Nazwa zawodów może zawierać maksymalnie 100 znaków",
    "competitionName.invalidPattern": "Nazwa może zawierać litery, cyfry, spacje oraz znaki: . , : ( ) / -",
    "shootingEvents.isEmpty": "Musisz wybrać co najmniej jedną konkurencję",
};

export type ValidationError = string;

const patternValidator = (data: string, pattern: RegExp, fieldKey: string): ValidationError | null => {
    return pattern.test(data) ? null : fieldKey + ".invalidPattern";
}

const sizeValidator = (data: string, minLength: number, maxLength: number, fieldKey: string): ValidationError | null => {
    if (data.length < minLength) {
        return fieldKey + ".tooShort";
    }
    if (data.length > maxLength) {
        return fieldKey + ".tooLong";
    }
    return null;
};

const validateEmail = (data: string): ValidationError[] => {
    const errors: (ValidationError | null)[] = [
        sizeValidator(data, 3, 30, "email"),
        patternValidator(data, /^[^\s@]+@[^\s@]+\.[^\s@]+$/, "email")
    ];

    return errors.filter((e): e is ValidationError => e !== null);
};

const validatePassword = (data: string): ValidationError[] => {
    const errors: (ValidationError | null)[] = [
        sizeValidator(data, 8, 64, "password"),
        patternValidator(data, /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).*$/, "password")
    ];

    return errors.filter((e): e is ValidationError => e !== null);
};

const validateCompetitionName = (data: string): ValidationError[] => {
    const errors: (ValidationError | null)[] = [
        sizeValidator(data, 3, 100, "competitionName"),
        patternValidator(data, /^[A-Za-z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ .,:()\/-]+$/, "competitionName")
    ];

    return errors.filter((e): e is ValidationError => e !== null);
};

const changeValidationMessages = (errors: ValidationError[]): string[] => {
    return errors.map(e => validationMessages[e] || e);
}

export enum ValidatorType {
    EMAIL = "EMAIL",
    PASSWORD = "PASSWORD",
    COMPETITION_NAME = "COMPETITION_NAME",
};

export const validatorFactory = (data: string, validatorType: ValidatorType): ValidationError[] => {
    switch (validatorType) {
        case ValidatorType.EMAIL:
            return changeValidationMessages(validateEmail(data));
        case ValidatorType.PASSWORD:
            return changeValidationMessages(validatePassword(data));
        case ValidatorType.COMPETITION_NAME:
            return changeValidationMessages(validateCompetitionName(data));
        default:
            return [];
    }
};